import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
    weigh_bridge_ticket_type_list: { status: "idle" },
};

export const weigh_bridge_ticket_type_list_Slice = createSlice({
    name: "weigh_bridge_ticket_type_list",
    initialState,
    reducers: {
        success_weigh_bridge_ticket_type_list: (state, action) => {
            state.weigh_bridge_ticket_type_list = { status: app_consts.SUCCESS, data: action.payload };
        },
        fail_weigh_bridge_ticket_type_list: (state, action) => {
            state.weigh_bridge_ticket_type_list = { status: app_consts.FAIL, message: action.payload };
        },
        reset_weigh_bridge_ticket_type_list: (state) => {
            state.weigh_bridge_ticket_type_list = { status: app_consts.IDLE };
        },
        loading_weigh_bridge_ticket_type_list: (state) => {
            state.weigh_bridge_ticket_type_list = { status: app_consts.LOADING };
        },
    }
});

export const { success_weigh_bridge_ticket_type_list, fail_weigh_bridge_ticket_type_list, reset_weigh_bridge_ticket_type_list, loading_weigh_bridge_ticket_type_list } = weigh_bridge_ticket_type_list_Slice.actions;

export default weigh_bridge_ticket_type_list_Slice.reducer;